module.exports = __webpack_public_path__ + "img/37cf357.jpg";